import { Action } from '@ngrx/store'
import * as ProfileTypes from './profile.types'
import { Profile } from './profile.interface'

export class FetchProfileRequest implements Action {
  readonly type = ProfileTypes.FETCH_PROFILE_REQUEST
  constructor() {}
}

export class FetchProfileSuccess implements Action {
  readonly type = ProfileTypes.FETCH_PROFILE_SUCCESS
  constructor(public payload: Profile) {}
}

export class FetchProfileFailure implements Action {
  readonly type = ProfileTypes.FETCH_PROFILE_FAILURE
  constructor(public payload: any) {}
}

export class UpdatePasswordRequest implements Action {
  readonly type = ProfileTypes.UPDATE_PASSWORD_REQUEST
  constructor(public payload: any) {}
}

export class UpdatePasswordSuccess implements Action {
  readonly type = ProfileTypes.UPDATE_PASSWORD_SUCCESS
  constructor() {}
}

export class UpdatePasswordFailure implements Action {
  readonly type = ProfileTypes.UPDATE_PASSWORD_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = ProfileTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = ProfileTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | SetDefaultData
  | UpdateField
  | FetchProfileRequest
  | FetchProfileSuccess
  | FetchProfileFailure
  | UpdatePasswordRequest
  | UpdatePasswordSuccess
  | UpdatePasswordFailure
